module.exports = __webpack_public_path__ + "img/flag-ca.3c533ae7.png";